import React from "react";

import IconButton from "@mui/joy/IconButton";
import Snackbar from "@mui/joy/Snackbar";

// icons
import ContentCopyIcon from '@mui/icons-material/ContentCopy';


class CommonCopyToClipboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            copied: false,
        };
    }

    async copyTextToClipboard() {
        try {
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(this.props.content);
                this.setState({
                    copied: true,
                })
            } else {
                console.warn('Clipboard API not available or writeText not supported.');
            }
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    }

    render() {
        return(
            <>
                <IconButton
                    size={'sm'}
                    onClick={this.copyTextToClipboard.bind(this)}
                    sx={this.props.sx?this.props.sx:{
                        mt: 0,
                        mb: 0,
                        mr: 0,
                        minHeight: '16px',
                        minWidth: '16px',
                    }}
                    color={this.props.color?this.props.color:'neutral'}
                    variant={this.props.variant?this.props.variant:'plain'}
                >
                    <ContentCopyIcon
                        sx={this.props.iconsx?this.props.iconsx:{
                            fontSize: '16px',
                        }}
                    />
                </IconButton>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.copied}
                    onClose={() => (this.setState({copied: false,}))}
                >
                    Скопированно
                </Snackbar>
            </>
        )
    }
}

export default CommonCopyToClipboard
